import {
  InactivateBookingsResponse,
  InactivateSeriesBookingDto
} from "../../../features/Schedule/schedule.types";
import { useRemoteMutation } from "../useRemote/useRemoteMutation";
import { useTranslation } from "react-i18next";

/** Success toast after series inactivate: empty `[]` means nothing was cancelled. */
export function seriesInactivateSuccessSnackbarText(
  inactivated: InactivateBookingsResponse[],
  t: (key: string) => string
): string {
  if (inactivated.length === 0) {
    return t("_schedule_seriesCancelNothingLeft");
  }
  return t("Successfully deleted bookings");
}

export function useRemoteInactivateSeriesBookings(snackbarTextOnSuccess?: string) {
  const { t } = useTranslation();

  return useRemoteMutation<InactivateBookingsResponse[], unknown, InactivateSeriesBookingDto>({
    key: "useRemoteInactivateSeriesBookings",
    method: "patch",
    url: `/booking/inactivate-series`,
    snackbarTextOnSuccess,
    snackbarTextFunOnSuccess:
      snackbarTextOnSuccess == null
        ? (data: InactivateBookingsResponse[]) => seriesInactivateSuccessSnackbarText(data, t)
        : undefined,
    snackbarTextOnFail: t("Error while deleting your bookings")
  });
}
